import { render, staticRenderFns } from "./TablaReportePedidoBodega.vue?vue&type=template&id=a6fc38c2"
import script from "./TablaReportePedidoBodega.vue?vue&type=script&lang=js"
export * from "./TablaReportePedidoBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports